import { render, staticRenderFns } from "./customConfig.vue?vue&type=template&id=321f9c51&scoped=true&"
import script from "./customConfig.vue?vue&type=script&lang=js&"
export * from "./customConfig.vue?vue&type=script&lang=js&"
import style0 from "./customConfig.vue?vue&type=style&index=0&id=321f9c51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f9c51",
  null
  
)

export default component.exports